export default __webpack_public_path__ + "static/10-44a18b46ae6710cccb64f94cdc7f461f.png";